import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";

@Component({
  selector: "sm-advance-payment-setting",
  templateUrl: "./advance-payment-setting.component.html",
  styleUrls: ["./advance-payment-setting.component.scss"],
})
export class AdvancePaymentSettingComponent implements OnInit, OnDestroy {
   home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  apisub: Subscription;
  toShowCheckShop: number = 0;
  toShowCheckHome: number = 0;
  toShowCheckVirtual: number = 0;
  shop_advance_type: number = 1;
  home_advance_type: number = 1;
  virtual_advance_type: number = 1;
  shop_advance_amount: number = 0;
  home_advance_amount: number = 0;
  virtual_advance_amount: number = 0;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private activemodal: MatDialogRef<AdvancePaymentSettingComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_BOOKING_ADVANCE_PAYMENT_SETTINGS
      ) {
        if (resdata.result) {
          this.toShowCheckShop = resdata.result.shop_service;
          this.toShowCheckHome = resdata.result.home_service;
          this.toShowCheckVirtual = resdata.result.virtual_service;

          this.shop_advance_type = resdata.result.shop_advance_type;
          this.home_advance_type = resdata.result.home_advance_type;
          this.virtual_advance_type = resdata.result.virtual_advance_type;

          this.shop_advance_amount = resdata.result.shop_advance_amount;
          this.home_advance_amount = resdata.result.home_advance_amount;
          this.virtual_advance_amount = resdata.result.virtual_advance_amount;
        }

        this.ls.showLoader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_BOOKING_ADVANCE_PAYMENT_SETTINGS
      ) {
        if (resdata.result) {
          this.ls.showLoader = false;
          this.activemodal.close({ msg: "success" });
        }
      }
    });
  }

  ngOnInit(): void {
    this.apiservice.getBookingAdvancePaymentSettings(
      this.parentdata.entityHash
    );
  }

  onToggleChange(event: any, type: any) {
    // shop
    if (type == 1) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckShop = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckShop = 0;
        this.shop_advance_type = 1;
        this.shop_advance_amount = 0;
      }
    }
    // home
    else if (type == 0) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckHome = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckHome = 0;
        this.home_advance_type = 1;
        this.home_advance_amount = 0;
      }
    }
    // virtual
    else if (type == 2) {
      // -------- CHECK LOGIC-----------
      if (event.checked) {
        this.toShowCheckVirtual = 1;
      }
      // -------- UNCHECK LOGIC -------------
      else if (!event.checked) {
        this.toShowCheckVirtual = 0;
        this.virtual_advance_type = 1;
        this.virtual_advance_amount = 0;
      }
    }
  }

  onSave() {
    let obj = {
      shop_service: this.toShowCheckShop,
      shop_advance_type: this.shop_advance_type,
      shop_advance_amount: this.shop_advance_amount,
      home_service: this.toShowCheckHome,
      home_advance_type: this.home_advance_type,
      home_advance_amount: this.home_advance_amount,
      virtual_service: this.toShowCheckVirtual,
      virtual_advance_type: this.virtual_advance_type,
      virtual_advance_amount: this.virtual_advance_amount,
      entity_hash: this.parentdata.entityHash,
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
    };

    console.log(obj);

    this.ls.showLoader = true;
    this.apiservice.setBookingAdvancePaymentSettings(obj);
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  changeShopAdvanceType(event: any) {
    console.log(event);
    if (event.value == 1) {
      this.shop_advance_amount = 0;
    }
  }
  changeHomeAdvanceType(event: any) {
    console.log(event);
    if (event.value == 1) {
      this.home_advance_amount = 0;
    }
  }
  changeVirtualAdvanceType(event: any) {
    console.log(event);
    if (event.value == 1) {
      this.virtual_advance_amount = 0;
    }
  }
}
